import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  translateMenu: (key: string) => string = () => '';
  translateChart: (key: string) => string = () => '';

  translateMenuItems(value: string): string {
    switch (value) {
      case 'Roles':
        return $localize`Roles`;
      case 'Users':
        return $localize`Users`;
      default:
        // Fall back to the name as supplied rather than undefined (which rendered as a BLANK
        // menu entry). Covers user-entered names - a role's Menu Group Name arrives already
        // translated by the API - and any DB menu name not registered in a translateMenu case.
        return value;
    }
  }
}
